<template>
  <div class="menu-button">
    {{ btName }}
  </div>
</template>

<script>
export default {
  props: {
    btName: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      isActive: false,
    }
  },
  methods: {
    handleEnter() {
      this.isActive = true
    },
    handleLeave() {
      this.isActive = false
    },
  },
}
</script>

<style lang="scss">
$fontColor: #eee;
$innerLight: rgba(
  $color: #bce6ec,
  $alpha: 0.5,
);
.menu-button {
  font-size: 14px;
  // font-weight: bold;
  color: $fontColor;
  line-height: 2.5em;
  height: 2.5em;
  padding: 0 1.5em;
  border-radius: 5px;
  margin-right: 10px;
  user-select: none;
  cursor: pointer;
}
.button-active {
  box-shadow: 0 0 1.5em $innerLight inset;
  background-color: #212a4b;
}
.button-inactive {
  box-shadow: 0 0 1.5em $innerLight inset;
  background-color: rgb(8, 14, 32);
}
</style>
